// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"98":"0244ec90","113":"ebd8be69","185":"2c7b47cc","323":"30eb8e48","425":"bfe9e76a","453":"f2fa0e2c","502":"e1b52145","514":"3846fda9","526":"7fa10797","550":"eb3fff02","777":"a5c9797a","817":"4a39d653","825":"171be43f","828":"d5e35379","858":"a1c04497","970":"244cc9a7"}[chunkId] + ".chunk.js";
};